export const maintenanceWorkflowSchedulesDefaultColumns = [
  { label: 'Id da programação', value: 'protocol_number' },
  { label: 'Nome', value: 'display_name' },
  { label: 'Descrição', value: 'observations' },
  { label: 'Tipo de manutenção', value: 'kind' },
  { label: 'Ações', value: 'action', className: 'w-9' },
];
